import { render } from "./TraditionalOfflineAdAgencyPage.vue?vue&type=template&id=fdcb13c6&ts=true"
import script from "./TraditionalOfflineAdAgencyPage.vue?vue&type=script&lang=ts"
export * from "./TraditionalOfflineAdAgencyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__